import AppointmentsDonePage from './AppointmentsDonePage';
export default AppointmentsDonePage